const elements = Array.from(document.querySelectorAll(".article h2, .article h3, .article h4"))
elements.forEach( element => {
    if(element.classList.length === 0) {
        element.classList.add("heading")
    }
} )

const headings = document.getElementsByClassName("heading")

const colors = [
    "-yellow",
    "-green",
    "-orange",
    "-blue"
]

for(let i = 0 ; i < headings.length ; i++) {
    headings[i].classList.add(colors[i % colors.length])
}
